import { Tooltip } from 'primereact/tooltip';
import React from 'react';

interface teamLeadPayoutPillStatus {
    status: string;
    icon: string;
    tooltip: string;
    bgColor: string;
}

interface propTypes {
    options?: any;
    Headertext?: string;
    pillDetails?: teamLeadPayoutPillStatus;
}

export const PillStatus = ({options, Headertext, pillDetails}:propTypes) => {
    const toggleIcon = options.collapsed ? 'pi pi-plus' : 'pi pi-minus';
    const className = `p-panel-header mt-0 shadow bg-body rounded border-1`;
    const btnClass:string|undefined = Headertext?.replace(' ', '');
    return (
        <div className={className} style={{ marginTop: '0px !important' }}>
            <span>{Headertext}</span>
            {pillDetails?.status !== '' ? (
                <button
                    className={Headertext?.replace(' ', '')}
                    style={{
                        color: 'white',
                        fontWeight:'700',
                        backgroundColor:
                            pillDetails?.bgColor && pillDetails.bgColor !== ''
                                ? `${pillDetails.bgColor}`
                                : '#E23636',
                        borderRadius: '3px',
                        border: 'none',
                        borderColor:
                            pillDetails?.bgColor && pillDetails.bgColor !== ''
                                ? `${pillDetails.bgColor}`
                                : '#E23636',
                        marginRight: 'auto',
                        marginLeft: '10px',
                        padding :'0.25rem 0.4rem',
                        cursor: 'auto',
                        fontSize:'0.75rem'
                    }}
                >
                    {pillDetails?.status}
                </button>
            ) : (
                ''
            )}
            {pillDetails?.tooltip !== '' ? (
                <Tooltip target={'.' + btnClass} style={{ backgroundColor: 'white' }}>
                    <img className="justify-content-left " src={pillDetails?.icon} alt="" />
                    {pillDetails?.tooltip}
                </Tooltip>
            ) : null}
            <button className={options.togglerClassName} onClick={options.onTogglerClick}>
                <span className={toggleIcon} />
            </button>
        </div>
    );
};
